import { useState } from "react";
import { topicWall } from "@/mocks/tracking";

export default function TopicWall() {
  const [frag, setFrag] = useState<string>("近 7 天");

  const frags = ["近 24h", "近 7 天", "近 30 天"];

  return (
    <section id="topic" className="w-full border-b border-line bg-cream">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-medium uppercase tracking-widest text-gold-text">
              Keyword Radar
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-ink md:text-3xl">
              话题墙 · 正在被议论的新词
            </h2>
            <p className="mt-2 text-sm text-muted">
              热度不等于真相，也常是流出的起点。把最近黑料相关的话题按热度与类型摊成一整面墙。
            </p>
          </div>

          {/* 分段切换 */}
          <div className="flex shrink-0 items-center gap-1 rounded-full border border-line bg-paper p-1">
            {frags.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setFrag(f)}
                className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition-colors ${
                  frag === f ? "bg-ink text-cream" : "text-muted hover:text-ink"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-2.5">
          {topicWall.map((t, i) => (
            <a
              key={t}
              href="#expose"
              className="group flex items-center gap-1.5 whitespace-nowrap rounded-md border border-line bg-card px-3.5 py-2 text-sm text-muted transition-colors hover:border-gold/50 hover:bg-gold-soft hover:text-ink"
            >
              <span className="text-[10px] font-semibold text-faint">#</span>
              {t}
              <span
                className={`hidden text-[10px] font-semibold sm:inline ${
                  i % 5 === 0 ? "text-mark-text" : "text-gold-text"
                }`}
              >
                {((i * 37) % 50) + 12}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}